import { createAction } from '@saucelabs/sl-util-redux';

import * as types from './types';


export const initialize = createAction(types.INITIALIZE);
